// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React examples
import SimpleInfoCard from "custom/Cards/InfoCards/SimpleInfoCard";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function Information() {
  return (
    <MKBox component="section" py={6} mt={6}>
      <Container>
        <Grid container spacing={3} item xs={12} lg={8} mx="auto">
          <MKTypography variant="h3" mb={7}>
            ¿Qué es la Ingeniería Social?
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Nuestros servicios de Defensa contra Ingeniería Social se centran en evaluar y mitigar las vulnerabilidades humanas dentro del marco de seguridad de tu organización. Simulamos varios ataques de ingeniería social, como phishing o pretexting, para educar y capacitar a tu personal mientras identificamos puntos débiles en tus defensas.
          </MKTypography>
          <MKTypography variant="h3" mb={7} mt={7}>
            Aspectos Clave de la Defensa contra Ingeniería Social
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="school"
                title="Educación y Capacitación"
                description="Los servicios de Defensa contra Ingeniería Social proporcionan educación y capacitación a las personas dentro de una organización para reconocer y resistir los intentos de ingeniería social. Esto incluye simulaciones de phishing, programas de concienciación y capacitación práctica para agudizar los instintos de seguridad de los empleados."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="view_in_ar"
                title="Ataques Simulados"
                description="Para evaluar la vulnerabilidad de una organización a la ingeniería social, estos servicios a menudo simulan escenarios de ataque del mundo real. Estas simulaciones ayudan a identificar debilidades en las defensas de la organización y proporcionan información sobre áreas que requieren mejora."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="policy"
                title="Evaluación de Políticas y Procedimientos"
                description="La Defensa contra Ingeniería Social evalúa las políticas y procedimientos de una organización relacionados con la protección de datos, el control de acceso y la respuesta a incidentes. Esto asegura que la organización tenga directrices robustas para contrarrestar los ataques de ingeniería social."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="diversity_3"
                title="Cultura de Concienciación"
                description="Más allá de los aspectos técnicos, la Defensa contra Ingeniería Social promueve una cultura de concienciación sobre ciberseguridad dentro de una organización. Se enfatiza la importancia de la vigilancia y la responsabilidad compartida de todos los empleados en mantener la seguridad."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            ¿Por qué Importa la Defensa contra Ingeniería Social?
          </MKTypography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="accessibility"
                title="Amenazas Centradas en el Ser Humano"
                description="Los ataques de ingeniería social explotan las vulnerabilidades humanas, lo que los hace difíciles de prevenir solo con medidas técnicas. La Defensa contra Ingeniería Social aborda esta brecha."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="radar"
                title="Detección Temprana"
                description="La educación y la capacitación empoderan a las personas para reconocer y reportar posibles intentos de ingeniería social, permitiendo la detección y prevención temprana de ataques."
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: { xs: 0, md: 1 } }}>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="healing"
                title="Mitigación de Riesgos"
                description="Al defenderse proactivamente contra la ingeniería social, las organizaciones pueden mitigar el riesgo de brechas de datos costosas, pérdidas financieras y daños a la reputación."
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <SimpleInfoCard
                icon="shield_lock"
                title="Defensa Integral"
                description="La Defensa contra Ingeniería Social complementa las medidas técnicas de ciberseguridad, creando una estrategia de defensa en capas que aborda tanto las amenazas técnicas como las centradas en el ser humano."
              />
            </Grid>
          </Grid>
          <MKTypography variant="h3" mb={7} mt={7}>
            El Rol de la Defensa contra Ingeniería Social en la Ciberseguridad
          </MKTypography>
          <MKTypography variant="body2" align="justify">
            Los servicios de Defensa contra Ingeniería Social son componentes esenciales de una estrategia integral de ciberseguridad. Ayudan a las organizaciones y a las personas a desarrollar resiliencia contra tácticas manipulativas, fomentando una cultura de seguridad consciente que está preparada para enfrentar los desafíos en constante evolución que plantean los ataques de ingeniería social. Al invertir en estos servicios, las organizaciones pueden reducir la probabilidad de caer víctimas de estas tácticas engañosas y proteger su información y activos sensibles.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;